import { createHmac } from "./createHmac";

export async function TOTP(secret: string) {
  const hmac = await createHmac("SHA-1", secret);

  // get current time
  let time = Math.floor(new Date().getTime() / 30000);

  // pack as 64-bit number
  const bytes = new Uint8Array(8);
  let i = 7;
  while (time > 0) {
    bytes[i--] = time & 0xff;
    time = Math.floor(time / 0x100);
  }

  // hash time
  const hash = await hmac.update(bytes).digest();
  const offset = hash[hash.length - 1] & 0x0f;
  const code =
    ((hash[offset] << 24) |
      (hash[offset + 1] << 16) |
      (hash[offset + 2] << 8) |
      hash[offset + 3]) &
    0x7fffffff;

  return (code % 10 ** 6).toString().padStart(6, "0");
}
